"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    accm: {
        logo: 'accm'
    },
    atlantic_eau: {
        logo: 'atlantic-eau'
    },
    cer: {
        logo: 'cer'
    },
    cgsp: {
        logo: 'cgsp'
    },
    cise_reunion: {
        logo: 'cise-reunion'
    },
    derichebourg: {
        logo: 'derichebourg'
    },
    eau_de_garonne: {
        logo: 'eau-de-garonne'
    },
    eau_de_morbihan: {
        logo: 'eau-de-morbihan'
    },
    eaux_saumur_val_de_loire: {
        logo: 'eaux-saumur-val-de-loire'
    },
    grand_lac: {
        logo: 'grand-lac'
    },
    ileo: {
        logo: 'ileo'
    },
    saint_affo: {
        logo: 'saint-affo'
    },
    saint_martin: {
        logo: 'saint-martin'
    },
    sateg: {
        logo: 'sateg'
    },
    saur_guadeloupe: {
        logo: 'saur-guadeloupe'
    },
    se3r: {
        logo_horizontal: 'se3r-color-horizontal',
        logo_vertical: 'se3r-color-horizontal'
    },
    martinique: {
        logo: 'saur-martinique'
    },
    vilivia: {
        logo: 'vilivia'
    },
    gpeau: {
        logo: 'saur-gpeau'
    },
    sepig: {
        logo: 'sepig'
    },
    sepra: {
        logo: 'sepra'
    },
    siaep_questembert: {
        logo: 'siaep-questembert'
    },
    sieccao: {
        logo: 'sieccao'
    },
    sudeau: {
        logo: 'sudeau'
    },
    sem: {
        logo: 'sem'
    },
    sbaa: {
        logo: 'sbaa'
    },
    gmva: {
        logo: 'gmva'
    }
};
